<template>
  <div
    class="game-card h-1/5 w-1/5"
    :class="classes"
    :style="styles"
    @click="toggleActive"
  >
    <div
      class="game-card__overlay"
      :class="item.type"
    ></div>
    <div class="flex h-full w-full items-center justify-center">
      <div v-if="!isSpymaster" class="">
        <div class="text-xs lg:text-lg opacity-50 rotate-180 text-center" style="transform: rotate(180deg);">{{ item.word }}</div>
        <div class="text-xl lg:text-3xl lg:font-light text-center">{{ item.word }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isSpymaster: {
      default: false,
      type: Boolean
    },

    item: {
      required: true
    }
  },

  computed: {
    classes () {
      return {
        "active": this.item.active,
        "isSpymaster": this.isSpymaster
      }
    },

    styles () {
      return {
      }
    }
  },

  methods: {
    toggleActive () {
      if (!this.isSpymaster) {
        this.item.active = !this.item.active
        this.$emit('clicked', {
          ...this.item
        })
      }
    }
  }
}
</script>

<style>
.game-card {
  @apply relative;
  @apply border border-black;
  @apply bg-white;

  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;

  background-position: center;
  background-repeat: no-repeat;
  background-size: auto 100%;
}

.game-card:hover {
  @apply bg-gray-300;
}

.game-card .game-card__overlay {
  @apply z-20;
  @apply absolute top-0 right-0 bottom-0 left-0;
  @apply opacity-0;

  /* mix-blend-mode: multiply; */
  transition: all 300ms;
}

.game-card .game-card__overlay.assassin { background-color: #212121 }
.game-card .game-card__overlay.red_agent { background-color: #e84333 }
.game-card .game-card__overlay.blue_agent { background-color: #375aee }
.game-card .game-card__overlay.bystander { background-color: #ccbfa9 }

/* .game-card:hover .game-card__overlay {
  @apply opacity-25;
} */

.game-card.active .game-card__overlay {
  @apply opacity-100;
}

.game-card.isSpymaster .game-card__overlay {
  @apply opacity-100;
  /* mix-blend-mode: multiply; */
}
</style>
